// @ts-nocheck
import React from 'react';

import * as styles from './styles';
import { BodyText, CloseButton, Popper } from '..';
import type { SvgIconProps } from '@material-ui/core';

import { CrmRequester, UpsellItem } from '@cobliteam/api-lib';

import { Alert } from '@cobliteam/alert';
import { Analytics } from '@cobliteam/analytics';
import { CookieManager } from '@cobliteam/cookie-manager';
import { Environment } from '@cobliteam/react-environments';

import { Button } from '@cobliteam/ui/components';

import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';

import { UpsellModal } from '../UpsellModal/UpsellModal';

export const COOKIE_NAME = 'vehicle_page_upsell';

const env = Environment.getInstance().getEnvironment();

export enum UpsellRequestState {
  REQUESTED = 0,
  REQUESTING = 1,
  NOT_REQUESTED = 2,
}

export interface UpsellButtonState {
  showModal: boolean;
  showTooltip: boolean;
  anchorEl: HTMLElement | null;
  upsellRequestState: UpsellRequestState;
}

export interface UpsellButtonProps {
  title: string;
  location?: string;
  className?: string;
  cookieName?: string;
  upsellItem?: UpsellItem;
  icon?:
    | React.FC<React.SVGProps<SVGSVGElement>>
    | ((props: SvgIconProps) => JSX.Element);
}

export class UpsellButton extends React.Component<
  UpsellButtonProps,
  UpsellButtonState
> {
  private crmRequester = new CrmRequester({ host: env.apiHost });

  constructor(props: UpsellButtonProps) {
    super(props);

    const hasUpsellModalOpen =
      window.location.hash.includes('upsell_modal=true');

    this.state = {
      showModal: hasUpsellModalOpen,
      showTooltip: false,
      anchorEl: null,
      upsellRequestState: this.getUpsellRequestStateFromCookie(),
    };
  }

  private handleClick = () => {
    Analytics.track('Upsell Request Button Clicked', {
      location: this.props.location || 'Vehicles Page',
    });

    this.setState({ showModal: !this.state.showModal });
  };

  private confirmRequest = (itemsAmount?: number): Promise<void> => {
    this.setState({ upsellRequestState: UpsellRequestState.REQUESTING });

    const twoSecondsInMillis = 2000;

    const item = this.props.upsellItem || UpsellItem.DEVICE;
    const sendSlackNotification = this.crmRequester.sendNotification(
      item,
      itemsAmount
    );
    const minimumLoadingTime = new Promise((resolve) =>
      setTimeout(resolve, twoSecondsInMillis)
    );

    return Promise.all([sendSlackNotification, minimumLoadingTime])
      .then(() => {
        Analytics.track('Upsell Request Confirmed After Button Click');
        Alert.success('Solicitação enviada com sucesso');
        this.setState({
          upsellRequestState: UpsellRequestState.REQUESTED,
          showTooltip: false,
          showModal: false,
          anchorEl: null,
        });
        this.setCookie();
      })
      .catch(() => {
        this.setState({
          upsellRequestState: UpsellRequestState.NOT_REQUESTED,
        });
        Alert.error('Houve um erro ao solicitar');
      });
  };

  private setCookie = () => {
    const oneWeekInMillis = 7 * 24 * 60 * 60 * 1000;
    const cookieName = this.props.cookieName || COOKIE_NAME;
    CookieManager.setCookie(cookieName, 'true', oneWeekInMillis);
  };

  private getUpsellRequestStateFromCookie = (): UpsellRequestState => {
    const cookieName = this.props.cookieName || COOKIE_NAME;
    const cookieValue = CookieManager.getCookie(cookieName);
    return cookieValue
      ? UpsellRequestState.REQUESTED
      : UpsellRequestState.NOT_REQUESTED;
  };

  private closeButtonClick = () => {
    Analytics.track('Upsell Request Canceled After Button Click');
    this.setState({ showModal: false, showTooltip: false, anchorEl: null });
  };

  public render() {
    const { showModal, showTooltip, anchorEl, upsellRequestState } = this.state;
    const { className, title, icon: Icon } = this.props;

    return (
      <>
        <Button
          color='success'
          size='condensed'
          startIcon={Icon ? <Icon /> : <DirectionsCarRoundedIcon />}
          className={className || ''}
          onClick={this.handleClick}
        >
          {upsellRequestState === UpsellRequestState.REQUESTED
            ? 'Recebemos sua solicitação'
            : title}
        </Button>

        {showTooltip && (
          <Popper
            arrow
            open={showTooltip}
            placement='bottom'
            anchorEl={anchorEl}
          >
            <div className={styles.upsellTooltip}>
              <div className={styles.upsellTooltipTitle}>
                Confirmar solicitação
                <CloseButton onClick={this.closeButtonClick} />
              </div>
              <BodyText className={styles.upsellTooltipText}>
                Confirme no botão abaixo para que nosso time de Sucesso do
                Cliente entre em contato com você
              </BodyText>
              <Button
                loading={upsellRequestState === UpsellRequestState.REQUESTING}
                onClick={this.confirmRequest}
              >
                Confirmar
              </Button>
            </div>
          </Popper>
        )}

        {showModal && (
          <UpsellModal
            onCancel={this.closeButtonClick}
            onConfirm={this.confirmRequest}
            isLoading={upsellRequestState === UpsellRequestState.REQUESTING}
          />
        )}
      </>
    );
  }
}
